import { MobileArticleTreatment, Visual, ZoneNames } from 'data/generated/graphql';

export const DATE_TIME_FORMAT = 'MMM dd, yyyy hh:mm aa';

export const FORBIDDEN_KEYS = [
  'start',
  'end',
  'value',
  'size',
  'show_flashline',
  'show_summary',
  'treatment',
  'visual'
];
export const OPTIONAL_PARAMETER_KEYS = ['display_type', 'red_flashline', 'center_text'];

export const SIZES = Object.values(ZoneNames).filter((size) => size !== ZoneNames.Xs);
export const TREATMENTS = Object.values(MobileArticleTreatment);
export const VISUAL = Object.values(Visual);
